import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { authUser } from "@origin-digital/event-dispatcher";
import { isNative } from "@origin-digital/platform-helpers";
import { config } from "../config";

type AppContextValue = {
  isAuthenticated: boolean;
  isNative: boolean;
};

const AppContext = createContext<AppContextValue>({
  isAuthenticated: false,
  isNative: false,
});

export const useAppContext = () => useContext(AppContext);

export const AppContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { isAuth } = await authUser({
          auth0Environment: config.env as EnvironmentNames,
        });
        setIsAuthenticated(Boolean(isAuth));
      } catch (error) {
        console.error("authUser failed", error);
      }
    };

    void checkAuth();
  }, []);

  const value = useMemo(
    () => ({
      isAuthenticated,
      isNative: isNative(),
    }),
    [isAuthenticated]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
